import React, {useEffect} from 'react';
import { NavLink } from 'react-router-dom';

const Home = ({ setIsHomepage }) => {

   useEffect(() => {
    setIsHomepage(true);
    // Add cleanup logic if needed
    return () => {
      setIsHomepage(false);
    };
  }, [setIsHomepage]);

  return (
    <div className="home">
        <div className="columns is-centered is-desktop">

            <div className="column is-half-desktop">
              <img src={process.env.PUBLIC_URL + "/img/home/bulb.jpg"} className="bulb" alt="" />
            </div>

            <div className="column is-half-desktop">
              <img src={process.env.PUBLIC_URL + "/img/home/rathbones-review.svg"} className="review" alt="" />
              <h2>2023</h2>
              <NavLink to="/welcome">Enter</NavLink>
            </div>
      </div>
    </div>
  );
}

export default Home;